import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/lib/auth";
import { type ReactNode, useEffect } from "react";
import { apiCall } from "@/lib/api";

type MeResponse = {
  id: string;
  email: string;
  nombre_completo: string | null;
  rol: { id: string; nombre: string; tipo: string } | null;
  permissions: string[];
};

/** Bloquea el acceso a rutas privadas si no hay accessToken.
 *  F84/F85: si el token existe pero `permissions` está vacío (sesión vieja
 *  pre-dev84 que no incluía permisos), llama a `/api/v1/me` y los hidrata.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  const permissions = useAuthStore((s) => s.permissions);
  const setPermissions = useAuthStore((s) => s.setPermissions);
  const setUser = useAuthStore((s) => s.setUser);
  const location = useLocation();

  useEffect(() => {
    if (token && permissions.length === 0) {
      apiCall<MeResponse>("get", "/api/v1/me")
        .then((me) => {
          setUser({
            id: me.id, email: me.email, nombre_completo: me.nombre_completo,
            rol: me.rol ? { id: me.rol.id, nombre: me.rol.nombre } : null,
          });
          setPermissions(me.permissions);
        })
        .catch(() => { /* token inválido — el siguiente request lo expulsará */ });
    }
  }, [token, permissions.length, setPermissions, setUser]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
